/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiProgramAssignAndUnAssignProgramToPortfolioPost } from '../fn/program/api-program-assign-and-un-assign-program-to-portfolio-post';
import { ApiProgramAssignAndUnAssignProgramToPortfolioPost$Params } from '../fn/program/api-program-assign-and-un-assign-program-to-portfolio-post';
import { apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain } from '../fn/program/api-program-assign-and-un-assign-program-to-portfolio-post-plain';
import { ApiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Params } from '../fn/program/api-program-assign-and-un-assign-program-to-portfolio-post-plain';
import { apiProgramGetProgramPost } from '../fn/program/api-program-get-program-post';
import { ApiProgramGetProgramPost$Params } from '../fn/program/api-program-get-program-post';
import { apiProgramGetProgramPost$Plain } from '../fn/program/api-program-get-program-post-plain';
import { ApiProgramGetProgramPost$Plain$Params } from '../fn/program/api-program-get-program-post-plain';
import { apiProgramGetProgramsPost } from '../fn/program/api-program-get-programs-post';
import { ApiProgramGetProgramsPost$Params } from '../fn/program/api-program-get-programs-post';
import { apiProgramGetProgramsPost$Plain } from '../fn/program/api-program-get-programs-post-plain';
import { ApiProgramGetProgramsPost$Plain$Params } from '../fn/program/api-program-get-programs-post-plain';
import { AssignProgramToPortfolioCommandResult } from '../models/assign-program-to-portfolio-command-result';
import { GetProgramQueryResult } from '../models/get-program-query-result';
import { GetProgramsQueriesResult } from '../models/get-programs-queries-result';

@Injectable({ providedIn: 'root' })
export class ProgramService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProgramGetProgramPost()` */
  static readonly ApiProgramGetProgramPostPath = '/api/Program/GetProgram';

  /**
   * بترجعلك برنامج ومعاه البروجكتات اللي تحت البرنامج.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProgramGetProgramPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramPost$Plain$Response(params?: ApiProgramGetProgramPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProgramQueryResult>> {
    return apiProgramGetProgramPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * بترجعلك برنامج ومعاه البروجكتات اللي تحت البرنامج.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProgramGetProgramPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramPost$Plain(params?: ApiProgramGetProgramPost$Plain$Params, context?: HttpContext): Observable<GetProgramQueryResult> {
    return this.apiProgramGetProgramPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProgramQueryResult>): GetProgramQueryResult => r.body)
    );
  }

  /**
   * بترجعلك برنامج ومعاه البروجكتات اللي تحت البرنامج.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProgramGetProgramPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramPost$Response(params?: ApiProgramGetProgramPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProgramQueryResult>> {
    return apiProgramGetProgramPost(this.http, this.rootUrl, params, context);
  }

  /**
   * بترجعلك برنامج ومعاه البروجكتات اللي تحت البرنامج.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProgramGetProgramPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramPost(params?: ApiProgramGetProgramPost$Params, context?: HttpContext): Observable<GetProgramQueryResult> {
    return this.apiProgramGetProgramPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProgramQueryResult>): GetProgramQueryResult => r.body)
    );
  }

  /** Path part for operation `apiProgramGetProgramsPost()` */
  static readonly ApiProgramGetProgramsPostPath = '/api/Program/GetPrograms';

  /**
   * بتاعه(id) بنرجعلك كل البرامج الخاصة بالبورتفوليو اللي انت بعت ال 
   * if portfolioId == null it will return all programs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProgramGetProgramsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramsPost$Plain$Response(params?: ApiProgramGetProgramsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProgramsQueriesResult>> {
    return apiProgramGetProgramsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * بتاعه(id) بنرجعلك كل البرامج الخاصة بالبورتفوليو اللي انت بعت ال 
   * if portfolioId == null it will return all programs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProgramGetProgramsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramsPost$Plain(params?: ApiProgramGetProgramsPost$Plain$Params, context?: HttpContext): Observable<GetProgramsQueriesResult> {
    return this.apiProgramGetProgramsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProgramsQueriesResult>): GetProgramsQueriesResult => r.body)
    );
  }

  /**
   * بتاعه(id) بنرجعلك كل البرامج الخاصة بالبورتفوليو اللي انت بعت ال 
   * if portfolioId == null it will return all programs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProgramGetProgramsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramsPost$Response(params?: ApiProgramGetProgramsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProgramsQueriesResult>> {
    return apiProgramGetProgramsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * بتاعه(id) بنرجعلك كل البرامج الخاصة بالبورتفوليو اللي انت بعت ال 
   * if portfolioId == null it will return all programs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProgramGetProgramsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramGetProgramsPost(params?: ApiProgramGetProgramsPost$Params, context?: HttpContext): Observable<GetProgramsQueriesResult> {
    return this.apiProgramGetProgramsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProgramsQueriesResult>): GetProgramsQueriesResult => r.body)
    );
  }

  /** Path part for operation `apiProgramAssignAndUnAssignProgramToPortfolioPost()` */
  static readonly ApiProgramAssignAndUnAssignProgramToPortfolioPostPath = '/api/Program/AssignAndUnAssignProgramToPortfolio';

  /**
   * في حالة ازاله البرنامج من البروتفوليو قم بارسال ال 
   * portfolioId = null.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Response(params?: ApiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignProgramToPortfolioCommandResult>> {
    return apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * في حالة ازاله البرنامج من البروتفوليو قم بارسال ال 
   * portfolioId = null.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain(params?: ApiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Params, context?: HttpContext): Observable<AssignProgramToPortfolioCommandResult> {
    return this.apiProgramAssignAndUnAssignProgramToPortfolioPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignProgramToPortfolioCommandResult>): AssignProgramToPortfolioCommandResult => r.body)
    );
  }

  /**
   * في حالة ازاله البرنامج من البروتفوليو قم بارسال ال 
   * portfolioId = null.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProgramAssignAndUnAssignProgramToPortfolioPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramAssignAndUnAssignProgramToPortfolioPost$Response(params?: ApiProgramAssignAndUnAssignProgramToPortfolioPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignProgramToPortfolioCommandResult>> {
    return apiProgramAssignAndUnAssignProgramToPortfolioPost(this.http, this.rootUrl, params, context);
  }

  /**
   * في حالة ازاله البرنامج من البروتفوليو قم بارسال ال 
   * portfolioId = null.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProgramAssignAndUnAssignProgramToPortfolioPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProgramAssignAndUnAssignProgramToPortfolioPost(params?: ApiProgramAssignAndUnAssignProgramToPortfolioPost$Params, context?: HttpContext): Observable<AssignProgramToPortfolioCommandResult> {
    return this.apiProgramAssignAndUnAssignProgramToPortfolioPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignProgramToPortfolioCommandResult>): AssignProgramToPortfolioCommandResult => r.body)
    );
  }

}
